import { useCallback } from "react";
import {
  IRoadLayoutConfig,
  IRoadConfigLayoutConfigCallBack,
  CarriageWayEnum,
  ILuminaireLayoutConfigCallBack,
  ILuminaireLayoutConfig,
  LuminaireLayoutEnum,
} from "types";
import { setObjectURL, getURL, setFromURLObject } from "utils/urls";

export const useRoadLayout = (
  roadLayoutConfig: IRoadLayoutConfig,
  luminaireLayoutConfig: ILuminaireLayoutConfig,
  onRoadLayoutConfig: IRoadConfigLayoutConfigCallBack,
  onLuminaireLayoutConfig: ILuminaireLayoutConfigCallBack
) => {
  getURL();
  setFromURLObject(roadLayoutConfig);

  const handleBorderSelect = useCallback(
    (name: string, checked: boolean) => {
      const key = name === "left" ? "borderAreaLeft" : name === "right" ? "borderAreaRight" : null;
      if (!key) return;

      const nextConfig = { ...roadLayoutConfig, [key]: checked };
      onRoadLayoutConfig(nextConfig);
      setObjectURL(nextConfig);
    },
    [onRoadLayoutConfig, roadLayoutConfig],
  );

  const handleCarriagewaySelect = useCallback(
    (value: string) => {
      const roadConfig = { ...roadLayoutConfig, carriageWay: value as CarriageWayEnum };
      const luminaireConfig = { ...luminaireLayoutConfig };

      const shouldSetBoth =
        value === CarriageWayEnum.DOUBLE || (value === CarriageWayEnum.SINGLE && luminaireLayoutConfig.luminaireConfig === LuminaireLayoutEnum.CENTERED_SINGLE);

      if (shouldSetBoth) {
        luminaireConfig.luminaireConfig = LuminaireLayoutEnum.BOTH;
      }

      onRoadLayoutConfig(roadConfig);
      setObjectURL(roadConfig);
      onLuminaireLayoutConfig(luminaireConfig);
      setObjectURL(luminaireConfig);
    },
    [luminaireLayoutConfig, onLuminaireLayoutConfig, onRoadLayoutConfig, roadLayoutConfig],
  );

  return { handleBorderSelect, handleCarriagewaySelect };
};
